var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H20C19.4477 3 19 3.44771 19 4V9C19 9.5523 19.4477 10 20 10H25C25.5523 10 26 9.5523 26 9V4C26 3.44771 25.5523 3 25 3Z",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14H20C19.4477 14 19 14.4477 19 15V20C19 20.5523 19.4477 21 20 21H25C25.5523 21 26 20.5523 26 20V15C26 14.4477 25.5523 14 25 14Z",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 3H31C30.4477 3 30 3.44771 30 4V9C30 9.5523 30.4477 10 31 10H36C36.5523 10 37 9.5523 37 9V4C37 3.44771 36.5523 3 36 3Z",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 14H31C30.4477 14 30 14.4477 30 15V20C30 20.5523 30.4477 21 31 21H36C36.5523 21 37 20.5523 37 20V15C37 14.4477 36.5523 14 36 14Z",
    stroke: "#030C21",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.9a3d0ade.svg";
export { ForwardRef as ReactComponent };